/// <reference types="./uniqueIndexUpdateValues.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ErrorType, notOk, ok } from '@dossierhq/core';
import { buildSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { UniqueIndexValueConstraint } from '../DatabaseSchema.js';
import { queryOne, queryRun } from '../QueryFunctions.js';
export async function adminEntityUniqueIndexUpdateValues(database, context, entity, values) {
    const conflictingValues = [];
    if (values.add.length > 0) {
        const addResult = await addValues(database, context, entity, values);
        if (addResult.isError())
            return addResult;
        conflictingValues.push(...addResult.value);
    }
    if (values.update.length > 0) {
        const updateResult = await updateValues(database, context, entity, values);
        if (updateResult.isError())
            return updateResult;
    }
    if (values.remove.length > 0) {
        const removeResult = await removeValues(database, context, values);
        if (removeResult.isError())
            return removeResult;
    }
    return ok({ conflictingValues });
}
async function addValues(database, context, entity, values) {
    function errorConverter(error) {
        if (database.adapter.isUniqueViolationOfConstraint(error, UniqueIndexValueConstraint)) {
            return notOk.Conflict('Conflict with unique index value');
        }
        return notOk.GenericUnexpectedException(context, error);
    }
    async function addValues(valuesToAdd) {
        return context.withTransaction(async (context) => {
            const query = buildSqliteSqlQuery(({ sql, addValue }) => {
                sql `INSERT INTO unique_index_values (entities_id, index_name, value, latest, published) VALUES`;
                const entityId = addValue(entity.entityInternalId);
                const trueValue = addValue(1);
                const falseValue = addValue(0);
                for (const { index, value, latest, published } of valuesToAdd) {
                    sql `, (${entityId}, ${index}, ${value}, ${latest ? trueValue : falseValue}, ${published ? trueValue : falseValue})`;
                }
            });
            return await queryRun(database, context, query, errorConverter);
        });
    }
    const failedValues = [];
    // first try to add all values
    const addAllResult = await addValues(values.add);
    if (addAllResult.isError()) {
        if (addAllResult.isErrorType(ErrorType.Generic)) {
            return notOk.Generic(addAllResult.message);
        }
        if (values.add.length === 1) {
            failedValues.push(values.add[0]);
        }
        else {
            // add one by one to set as many as possible
            for (const value of values.add) {
                const addOneResult = await addValues([value]);
                if (addOneResult.isError() && addOneResult.isErrorType(ErrorType.Generic)) {
                    return notOk.Generic(addOneResult.message);
                }
                failedValues.push(value);
            }
        }
    }
    return ok(failedValues);
}
async function updateValues(database, context, entity, values) {
    for (const { index, value, latest, published } of values.update) {
        const result = await queryOne(database, context, buildSqliteSqlQuery(({ sql }) => {
            sql `UPDATE unique_index_values SET latest = ${latest ? 1 : 0}, published = ${published ? 1 : 0} WHERE index_name = ${index} AND value = ${value} RETURNING entities_id`;
        }));
        if (result.isError())
            return result;
        if (result.value.entities_id !== entity.entityInternalId) {
            return notOk.Generic('Conflict with unique index value');
        }
    }
    return ok(undefined);
}
async function removeValues(database, context, values) {
    for (const { index, value } of values.remove) {
        //TODO include entity id?
        const result = await queryRun(database, context, buildSqliteSqlQuery(({ sql }) => {
            sql `DELETE FROM unique_index_values WHERE index_name = ${index} AND value = ${value}`;
        }));
        if (result.isError())
            return result;
    }
    return ok(undefined);
}
//# sourceMappingURL=uniqueIndexUpdateValues.js.map